import { render, staticRenderFns } from "./TraktShow.vue?vue&type=template&id=2d48637f&"
import script from "./TraktShow.vue?vue&type=script&lang=js&"
export * from "./TraktShow.vue?vue&type=script&lang=js&"
import style0 from "./TraktShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports